module.exports = __webpack_public_path__ + "img/scanSymbol.b4279343.svg";